import { render, staticRenderFns } from "./numr.vue?vue&type=template&id=0a474da9&scoped=true"
import script from "./numr.vue?vue&type=script&lang=js"
export * from "./numr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a474da9",
  null
  
)

export default component.exports